<template>
  <div class="LogViewer">
    <table class="Main-table" cellpadding="0" cellspacing="0">
      <thead>
        <tr>
          <th>Time</th>
          <th>Zone</th>
          <!-- <th>Level</th> -->
          <th>Type</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs">
          <td v-text="$time.format(log.time, 'verbose')" class="nowrap"></td>
          <td v-text="log.instance" class="nowrap"></td>
          <!-- <td v-text="log.level"></td> -->
          <td v-text="log.caller"></td>
          <td v-text="typeof log.message == 'object' ? JSON.stringify(a2C(log.message)) : a2C(log.message)"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import axios from 'axios';

// Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'page-log-viewer',
  props: ['logs'],
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {

  },
  created() {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="stylus" scoped>
  
  .nowrap
    white-space nowrap

  table.Main-table
    width 100%
    
    thead
      border-bottom 1px solid rgba(0,0,0,.1);

      th
        color #999
        padding 8px 12px
        border-right 1px solid rgba(0,0,0,.1);
        border-bottom 1px solid rgba(0,0,0,.1);
        font-size 14px
        font-weight normal
        text-transform uppercase

        &:last-child
          border-right 0

    tbody
      background #f9f9f9

      tr
        border-bottom 1px solid rgba(0,0,0,.1);

        &.status-playing
          background #ffc
          box-shadow inset 0 0 5px 3px rgba(255,255,255,1), 0 2px 5px rgba(0,0,0,.1)

          &:hover
            background #ffc
            box-shadow inset 0 0 5px 3px rgba(255,255,255,1), 0 2px 8px rgba(0,0,0,.15);

        &.status-stopped
          background #fff
          box-shadow 0 2px 5px rgba(0,0,0,.1)
          

        &:last-child
          border-right 0

        &:hover
          box-shadow 0 0 4px rgba(0,0,0,0.1);
          background #fff

        td
          border 0
          padding 8px 12px
          font-size 14px

          button
            background #fff
            box-shadow 0 1px 3px rgba(0,0,0,.1);
            border 1px solid rgba(0,0,0,.1);
            border-radius 4px
            padding 4px 7px
            
            &:hover
              border 1px solid rgba(0,0,0,.2);
              box-shadow 0 1px 5px rgba(0,0,0,.2);

        td.history
          color #999

      
</style>
